// extracted by mini-css-extract-plugin
export default {"container":"office_container__Hfwi8"};